import {
  InventoryType,
  ItemStatus,
  PersonType,
  SizeType
} from "../../constants/constant";

export const INITIAL_PRODUCT_INFO = {
    prdId: "",
    prdName: "",
    brandName: "",
    hsnCode: "",
    rack_no: "",
    composition: [],
    compositionStr: "",
    stockUsage: [],
    stockSideEffects: [],
    stockStorage: "",
    itemStatus: ItemStatus.ACTIVE,
    itemStatusStr: "",
    aboutItem: "",
};

export const INITIAL_CATEOGORY_ITEM = {
    inventoryTypeStr: "",
    catgName: "",
    catgId: "",
    inventoryType: InventoryType.None,
};

export const INITIAL_COLOR_MODEL = {
    colorId: "",
    colorCode: "",
    colorDetails: "",
}

export const INITIAL_DIAL_COLOR_MODEL = {
    colorId: "",
    colorDetails: "",
}

export const INITIAL_INVENTORY_DETAILS = {
    id: "",
    sizeType: SizeType.None,
    personType: PersonType.None,
    allowedDelete: false,
    productImage: [],
    itemStatus: ItemStatus.ACTIVE,
    caseMetal: "",
    condition: "",
    lugWidth: "",
    caseSize: "",
    jewels: "",
    movementType: "",
    waterResistance: "",
}

export const INITIAL_CONVERSION_SINGLE_DATA = {
    id: "",
    unitName: "",
    unitRestrictions: false,
    smallUnitName: "",
    smallUnitCount: 1,
    cnvDetails: "",
    decimalSmRestrictions: false,
};

export const INITIAL_OTHER_INVENTORYDETAILS = {
    otherInventoryDetails: [],
    otherInventoryDetailsSize: 0,
};

export const INITIAL_SUGGESESTED_ITEM = {
    listItemSuggestion: [],
    listSuggestedItemDeleted: [],
    suggestionAvail: false,
};


export const INITIAL_GOLD_INVENTORY_FORM = {
    name: "",
    brandName: "",
    articleNumber: "",
    tags: [],
    images: [],
    image: "",
    tagsComma: "",
    itemStatus: ItemStatus.ACTIVE,
    itemStatusStr: "",
    aboutItem: "",
    on: "",
    id: "",
    showBrandName: true,
};

export const INITIAL_KARAT_INFO = {
    id: "",
    karat: 0,
    hallMark: 0,
    pure: 0,
    partsGold: "",
    goldPerc: 0.0,
};

export const INITIAL_GOLD_RECORD_FORM = {
    serialNo: "",
    weight: 0,
    conversionId: "",
    imagePath: "",
    gifPath: "",
    toleranceLevel: 0.0,
    toleranceLevelInPercantage: 0.0,
    itemStatus: ItemStatus.ACTIVE,
    itemStatusStr: "",
    showStamp: false,
    showKaratInfo: false,
    showTolerance: false,
    showLogo: false,
    on: "",
    id: "",
};

export const INITIAL_SUPPLIER = {
    supId: "",
    supplierId: "",
    supplierName: "",
    logo: "",
};